import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => step.description;

export const getDescription = ({ step: { details }, t }) => {
  return `${t('Audio Transcription from ')} ‘${details?.sourceField?.label || t('File')}’ field`;
};

export default function AudioTranscriptionCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
